import { Phone, Navigation, ClipboardCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS, mapsDirUrl } from "../../config/business";

export default function MobileActionBar() {
  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-3 border-t border-line bg-white/95 backdrop-blur"
      data-testid="mobile-action-bar"
    >
      <a href={`tel:${BUSINESS.phoneTel}`} data-testid="mab-call" className="flex flex-col items-center gap-1 py-2.5 text-volt">
        <Phone className="h-5 w-5" />
        <span className="text-[11px] font-head font-bold">Call</span>
      </a>
      <a href={mapsDirUrl()} target="_blank" rel="noreferrer" data-testid="mab-directions" className="flex flex-col items-center gap-1 py-2.5 text-ink border-x border-line">
        <Navigation className="h-5 w-5" />
        <span className="text-[11px] font-head font-bold">Directions</span>
      </a>
      <Link to="/services/smog-check-modesto" data-testid="mab-service" className="flex flex-col items-center gap-1 py-2.5 text-ink">
        <ClipboardCheck className="h-5 w-5" />
        <span className="text-[11px] font-head font-bold">Smog Check</span>
      </Link>
    </div>
  );
}
